import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskReceivedRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskReceivedRPage;

